import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
function SvgWarningAlt(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={ref}
      {...props}
    >
      <circle cx={16} cy={16} r={16} fill="#F27500" />
      <path
        fill="white"
        fillRule="evenodd"
        d="M14.2488 6.99963H17.7488L17.2488 16.9996H14.7488L14.2488 6.99963ZM13.8 22.1996C13.8 20.9846 14.785 19.9996 16 19.9996C17.2151 19.9996 18.2001 20.9846 18.2001 22.1996C18.2001 23.4147 17.2151 24.3996 16 24.3996C14.785 24.3996 13.8 23.4147 13.8 22.1996Z"
        clipRule="evenodd"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgWarningAlt);
export default ForwardRef;
ForwardRef.defaultProps = {
  "aria-hidden": true,
  focusable: "false",
  role: "img",
};
